module.exports = __webpack_public_path__ + "assets/img/8dc6-at.svg";